
import "../Foundation/stylable/colors.st.css.js";
import "../Text/Text.st.css.js";

import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_209_0_ListItemSection";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_209_0_ListItemSection__root","title":"wds_1_209_0_ListItemSection__title","titleWrapper":"wds_1_209_0_ListItemSection__titleWrapper","suffixWrapper":"wds_1_209_0_ListItemSection__suffixWrapper","suffix":"wds_1_209_0_ListItemSection__suffix"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-color-border-dark-secondary":"--wds-color-border-dark-secondary","wds-color-fill-surface-neutral":"--wds-color-fill-surface-neutral","wds-list-item-section-fill":"--wds-list-item-section-fill","wds-color-text-placeholder":"--wds-color-text-placeholder","wds-color-text-standard-secondary":"--wds-color-text-standard-secondary","wds-list-item-section-padding-horizontal":"--wds-list-item-section-padding-horizontal","wds-list-item-section-font-size":"--wds-list-item-section-font-size","wds-list-item-section-line-height":"--wds-list-item-section-line-height","wds-space-100":"--wds-space-100","wds-space-150":"--wds-space-150","wds-space-200":"--wds-space-200"}; 




